/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Aúnque la organización de los archivos y de las carpetas depende mucho del desarrollador, cada librería tiene ciertas especificaciones muy generales para que la aplicación funcione.`}</p>
    <p>{`De cualquier modo, las 4 tecnologías logran el mismo fin por diferentes caminos.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;